export const StoryChapter = ({ chapter }) => <section className="story-chapter" id={chapter.id} aria-labelledby={`chapter-heading-${chapter.id}`} data-testid={`story-chapter-${chapter.id}`}>
  <div className="story-chapter-title"><span aria-hidden="true">{chapter.number}</span><h2 id={`chapter-heading-${chapter.id}`} data-testid={`story-heading-${chapter.id}`}>{chapter.title}</h2></div>
  {chapter.blocks.map((block, index) => block.type === 'paragraph'
    ? <p key={index} className="story-narration" data-testid={`${chapter.id}-paragraph-${index}`}>{block.text}</p>
    : <div key={index} className={`story-exchange story-${block.type}`} data-testid={`${chapter.id}-${block.type}-${index}`}>
      <span className="story-speaker">{block.type === 'question' ? 'INTERVIEWER' : 'BRAD'}</span>
      {block.type === 'answer' ? <blockquote><p>“{block.text}”</p></blockquote> : <p>{block.text}</p>}
    </div>)}
</section>;

export const StoryPullQuote = ({ quote, index }) => <figure className="story-pullquote" data-testid={`story-pullquote-${index}`}>
  <span className="story-quote-mark" aria-hidden="true">“</span>
  <blockquote><p>{quote}</p></blockquote>
  <figcaption>— Brad, Longhorn Milling</figcaption>
</figure>;